import { useState } from "react";
import { Modal, Box, Typography, Button, Grid } from "@mui/material";
import { PALETTE } from "../Theme/Palette";
import DatePicker from "../components/DatePicker";
import { useDate } from "../hooks";
import BaseTextArea from "../components/all-inputs/BaseTextArea";

const ConfirmModal = ({
  message,
  open,
  onClose,
  onSubmit,
  withDiscription = false,
  withTimePicker = false,
}) => {
  const [messageText, setMessageText] = useState("");
  const { convertDate, persian, persian_fa, gregorian, gregorian_en } = useDate();
  const [datePicker, setDatePicker] = useState();
  const [error, setError] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    if (withDiscription) {
      if (messageText && messageText !== "") {
        onSubmit({ body: messageText });
      } else setError("لطفا دلیل انصراف را وارد نمایید.");
    } else if (withTimePicker) {
      if (datePicker || datePicker !== undefined) {
        onSubmit({
          marriageDate: `${convertDate(
            datePicker,
            { calendar: persian, locale: persian_fa, format: "YYYY-MM-DD" },
            { calendar: gregorian, locale: gregorian_en, format: "YYYY-MM-DDTHH:mm:ss.SSSZ" }
          )}`,
        });
        setDatePicker();
      } else {
        setError("لطفا تاریخ عقد را وارد نمایید.");
      }
    } else {
      onSubmit();
    }
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Box component="form" width="100%" onSubmit={handleSubmit}>
        <Box
          width="90% !important"
          maxWidth="500px"
          marginX="auto"
          sx={{
            backgroundColor: "#FFF",
            boxSizing: "border-box",
            padding: "2rem",
            borderRadius: "1.5rem",
          }}
        >
          <Grid item width="100%" position="relative">
            {withTimePicker && (
              <Box width="100%">
                <Typography
                  fontSize="1.25rem"
                  fontWeight="bold"
                  letterSpacing="-0.0175rem"
                  sx={{ direction: "rtl", color: PALETTE.eightth }}
                  mb={3}
                >
                  تاریخ عقد
                </Typography>
                <Typography
                  fontSize="0.85rem"
                  fontWeight={400}
                  letterSpacing="-0.0175rem"
                  sx={{ direction: "rtl", color: PALETTE.eightth, margin: "0.8rem 0 0.65rem 0" }}
                >
                  متقاضي گرامي لطفا تاریخ عقد خود را وارد نمایید.
                </Typography>
                <DatePicker
                  onChange={(date) => setDatePicker(date ? date.format() : "")}
                  value={datePicker}
                  placeholder="تاریخ عقد"
                  labelFlex={0}
                  flex={12}
                />
              </Box>
            )}
            {withDiscription ? (
              <Grid xs={12} mb={3}>
                <Typography
                  fontSize="1.25rem"
                  fontWeight="bold"
                  letterSpacing="-0.0175rem"
                  sx={{ direction: "rtl", color: PALETTE.eightth }}
                >
                  دليل انصراف
                </Typography>
                <Typography
                  fontSize="0.85rem"
                  fontWeight={400}
                  letterSpacing="-0.0175rem"
                  sx={{ direction: "rtl", color: PALETTE.eightth, margin: "0.8rem 0 0 0" }}
                  pb={1.5}
                >
                  متقاضي گرامي لطفا دليل انصراف خود را بنويسيد.
                </Typography>
                <BaseTextArea
                  placeholder="اینجا بنویسید..."
                  minRows={4}
                  maxRows={4}
                  pb={3}
                  flex={12}
                  messageWhenValueMissing=""
                  onChange={(event) => {
                    setMessageText(event.target.value);
                    if (event.target.value.length !== 0) {
                      setError("");
                    }
                  }}
                />
              </Grid>
            ) : (
              <Typography
                fontSize="0.9rem"
                fontWeight={400}
                letterSpacing="-0.0175rem"
                sx={{ direction: "rtl", color: "#000", marginBottom: "2rem" }}
              >
                {!withTimePicker && message}
              </Typography>
            )}
            {(withDiscription || withTimePicker) && (
              <Box
                width="100%"
                sx={{
                  position: "absolute",
                  right: 2,
                  bottom: -20,
                  direction: "rtl",
                  color: "#FF0000",
                  fontSize: "0.7rem",
                  fontWeight: "500",
                }}
              >
                {error.length !== 0 && error}
              </Box>
            )}
          </Grid>
          <Box display="flex" flexDirection="row-reverse" width="100%">
            <Button
              variant="m1"
              type="submit"
              sx={{
                flex: 1,
                marginLeft: 1,
              }}
            >
              تایید
            </Button>
            <Button
              variant="m1"
              type="button"
              sx={{
                flex: 1,
                color: "#4C466F",
                marginRight: 1,
                backgroundColor: "#E8E8E8 !important",
                background: "none",
                fontWeight: 500,
                fontSize: "16px",
              }}
              onClick={() => {
                onClose();
                setError("");
                setDatePicker();
                setMessageText("");
              }}
            >
              انصراف
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmModal;
